<template>
	<div class="page">
		<div class="page-inner">
			<img src="/images/walter.png" />
			<h1>Let's create your<br/>personalised sleepmix</h1>
			<transition name="bounce">
				<div v-if="bounce" class="name">
					<input @keydown="enterPress" ref="input" class="name-input" v-model="name" type="text" placeholder="Name">
					<div class="name-label" v-if="!inputOpen" @click="selectInput">Enter first name</div>
					<transition name="slidedown">
						<div v-if="warning" class="warning">Please use another name</div>
					</transition>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { profanityFilter } from '../helpers/profanityFilter.js';
export default {
	data() {
		return {
			name: "",
			inputOpen: false,
			warning: false,
			bounce: false,
		}
	},
	mounted() {
		this.bounce = true;
	},
	watch: {
		name: function(newName) {
			const nameValidated = this.checkName(newName);
			if (nameValidated) localStorage.setItem("name", newName);
			this.nameValidated = nameValidated;
			this.warning = newName.length < 1 ? false : !nameValidated;
			this.$emit('allowForwards', nameValidated);
		},
	},
    beforeRouteLeave (to, from, next) {
        this.$emit('allowForwards', false);
        next()
    },
	methods: {
		checkName(name) {
			name = name.replace(/\s+/g, '');
			name = name.toLowerCase();
			if (name.length > 0 && profanityFilter(name)) {
				return true;
			}
			else {
				return false;
			}
		},
		selectInput() {
			this.gaEvent('Walter Name Page', 'Clicked name entry box')
			this.$refs.input.focus()
			this.inputOpen = true;
		},
		enterPress(e) {
			if (e.keyCode === 13 && this.nameValidated) {
				this.$router.push({name: 3});
			}
		}
	}
};
</script>

<style scoped>
input:focus, input:active {
	outline: none;
}

.page {
	background: #95ddcf;
}

img {
    position: absolute;
    transform: translateY(0%);
	bottom: 0;
	width: 1150px;
}

.mobile img {
    top: 180px;
    width: 950px;
}

.name {
    display: flex;
    align-items: center;
	justify-content: center;
	position: relative;
	width: 18rem;
    height: 8rem;
}

.desktop .name {
    position: absolute;
    bottom: 0;
    margin-bottom: 345px;
    width: 280px;
    height: 110px;
}

.mobile .name {
	top: 424px;
	position: absolute;
}

@media (max-height: 1100px) {
	.desktop img {
		transform: translateY(10%);
	}
	.desktop .name {
		margin-bottom: 270px;
	}
}

@media (max-height: 1000px) {
	.desktop img {
		transform: translateY(15%);
	}
	.desktop .name {
		margin-bottom: 230px;
	}
}

@media (max-height: 900px) {
	.desktop img {
		transform: translateY(25%);
	}
	.desktop .name {
    	margin-bottom: 160px;
	}
}

@media (max-height: 800px) {
	.desktop img {
		transform: translateY(35%);
	}
	.desktop .name {
		margin-bottom: 80px;
	}
}

.name-input {
    position: absolute;
	height: 100%;
	width: 100%;
    border-radius: 0.5rem;
    border:  none;
    box-shadow: 0px 2px 4px 0px grey;
    font-size: 1.8rem;
    text-align: center;
    color: white;
	background: var(--pink);
	z-index: 1;
}

.name-input::placeholder {
	color: #ffffff66;
}

.name-label {
    position: absolute;
    z-index: 1;
    color: var(--pink);
	height: 100%;
	width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 0.5rem;
    font-size: 1.8rem;
    padding: 1rem;
    text-align: center;
    line-height: 1.2;
	font-weight: bold;
	letter-spacing: 0.1px;
}

.warning {
	position: absolute;
    color: #ffffff;
    font-size: 0.8rem;
    background: #00000080;
    padding: 0.5rem;
	border-radius: 0.5rem;
	transform: translateY(80px);
}

.slidedown-enter-active, .slidedown-leave-active {
	transition: all 0.3s ease;
}

.slidedown-enter, .slidedown-leave-to {
  transform: translateY(0px);
}
</style>
